import { createSlice } from "@reduxjs/toolkit";
import { DOCUMENT_LOAD_STATUS } from "../../constants/metaData";

const initialState = {
  recentObjectConnection: [],
  recentObjectDataLoadStatus: DOCUMENT_LOAD_STATUS.onStart,
  recentObjectDataErrorMessage: "",
  selectedObjectConnections: [],
  recentObjectsRowSelectionDetails: [],
  recentObjectsSelected: [],
  recentObjectsSelectedDecription: "",
  advObjConColumns: [],
  mruKeyNames: [],
  advObjConSearchResult: [],
  advObjConSelectedRows: [],
  advSearchSelectedObjs: [],
};

const objectConnectionSlice = createSlice({
  name: "checkin/objectConnection",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase("ON_RECENT_OBJECTS_CHANGED", (state, action) => {
        state.recentObjectConnection = action.payload;
      })
      .addCase("ON_RECENT_OBJECTS_DATA_LOAD_STATUS", (state, action) => {
        state.recentObjectDataLoadStatus = action.payload;
      })
      .addCase("ON_RECENT_OBJECTS_DATA_ERROR_MESSAGE", (state, action) => {
        state.recentObjectDataErrorMessage = action.payload;
      })
      .addCase("ON_SELECTED_OBJECTS_CHANGED", (state, action) => {
        state.selectedObjectConnections = action.payload;
      })
      .addCase("ON_ROW_SELECTION_CHANGE_RECENT_OBJECTS", (state, action) => {
        state.recentObjectsRowSelectionDetails = action.payload;
      })
      .addCase("ON_RECENT_OBJECT_SELECTED", (state, action) => {
        state.recentObjectsSelected = action.payload;
      })
      .addCase("ON_RECENT_OBJECT_SELECTED_DESCRIPTION", (state, action) => {
        state.recentObjectsSelectedDecription = action.payload;
      })
      .addCase("ON_ROW_SELECTION_CHANGE_SEARCH_OBJECTS", (state, action) => {
        state.advObjConSelectedRows = action.payload;
      })
      .addCase("ON_ADV_OBJ_CON_COLUMNS_CHANGED", (state, action) => {
        state.advObjConColumns = action.payload;
      })
      .addCase("ON_MRU_KEYNAMES_CHANGED", (state, action) => {
        state.mruKeyNames = action.payload;
      })
      .addCase("ON_ADV_OBJ_CON_SEARCH_RESULT_CHANGED", (state, action) => {
        state.advObjConSearchResult = action.payload;
      })
      .addCase("ON_ADV_OBJ_SELECTED", (state, action) => {
        state.advSearchSelectedObjs = action.payload;
      });
  },
});

export default objectConnectionSlice.reducer;
